import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import {stepToPage} from '../../../actions/uiActions';
import useStyles from './ProgressBarCounter.styles';
import progressBarMapStateToProps from '../ProgressBarMapStateToProps';
import CheckIcon from '../../../../imgs/CheckIcon';

export function ProgressBarCounter(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  return (
    <div
      className={classes.counter}
      id={`ProgressBarCounter-${props.number}`}
      onClick={() => props.stepToPage(props.number)}
      aria-hidden="true"
    >
      <div className={classes.counterContainer}>
        <div
          className={classes.counterNumber}
          data-test="ProgressBarCounter__icon"
        >
          {!props.complete
            ? props.number
            : <CheckIcon className={classes.counterIcon} />}
        </div>
      </div>
    </div>
  );
}

ProgressBarCounter.propTypes = {
  number: PropTypes.number.isRequired,
  stepToPage: PropTypes.func.isRequired,
  
  active: PropTypes.bool.isRequired,
  complete: PropTypes.bool.isRequired,
};

export default connect(progressBarMapStateToProps, {stepToPage})(ProgressBarCounter);
